import React, {ReactNode} from "react";
import {Card, SimpleCardHeading} from "peggirkit";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";

type Props = {
    title: ReactNode,
    children: ReactNode,
};

/**
 * A section of the day report: a card with a title.
 */
const ReportCard = ({title, children}: Props) => (
    <Card
        header={
            <CardHeader>
                <SimpleCardHeading title={title}/>
            </CardHeader>
        }
    >
        {children}
    </Card>
);

export default ReportCard;